/**
 * @file Contém o enum com indices do DOM
 */
const indices = {
    EDICAO: 'dompbh-edicoes',
    ATO: 'dompbh-atos',
    ANEXOATO: 'dompbh-anexosatos'
}
    
export default indices;
